<script setup>
import { ref, onMounted } from "vue"
import { useRoute } from "vue-router"
import Layout from "../../layouts/main.vue"
import PageHeader from "@/components/page-header"
import CustomerLocation from "./CustomerLocation.vue"

import * as persianTools from "@persian-tools/persian-tools"

import { useParseDiscountDetails } from "../../use/useParseDiscountDetails"

import store from "../../state/store"

const title = "جزئیات سفارش"
const items = ref([
  {
    text: "سفارشات",
    href: "/dashboard/orders",
  },
  {
    text: "جزئیات سفارش",
    active: true,
  },
])

/* const props = defineProps({
  id: {
    require: true,
    type: String,
  },
}) */

const route = useRoute()
const id = route.params.id

const orderDetails = ref([])
const userInfo = ref()
const customerLocation = ref(null)

const statusLabels = {
  PAYING: "در حال پرداخت",
  PENDING: "در انتظار تایید (در حال بررسی)",
  PREPARING_TO_SEND: "آماده سازی برای ارسال",
  DELIVERED: "تحویل داده شده",
  CANCELLED: "لغو شده",
}

const transactionStatusLabels = {
  STATUS_FAILED: "تراکنش ناموفق",
  STATUS_PENDING: "در حال انجام",
  STATUS_SUCCESS: "تراکنش موفق",
}

onMounted(async () => {
  const { data } = await store.dispatch("getOrder", id)
  orderDetails.value = {
    ...data.data,
  }

  if (orderDetails.value.deliveryLat && orderDetails.value.deliveryLong) {
    customerLocation.value = [
      orderDetails.value.deliveryLat,
      orderDetails.value.deliveryLong,
    ]
  }

  const userData = await store.dispatch("getUser", orderDetails.value.user_id)
  userInfo.value = {
    ...userData.data.data,
  }

  console.log(orderDetails.value)
})

const { parseDiscountDetails, formattedPrices } = useParseDiscountDetails()
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <b-row>
      <b-col xl="9">
        <b-card no-body>
          <b-card-header>
            <div class="d-flex align-items-center">
              <h5 class="card-title flex-grow-1 mb-0">
                شماره سفارش:
                {{
                  orderDetails.trackingCode
                    ? persianTools.digitsEnToFa(orderDetails.trackingCode)
                    : orderDetails.trackingCode
                }}
              </h5>
              <div class="flex-shrink-0">
                <RouterLink
                  :to="{
                    name: 'orders.details.invoice',
                    params: { id: id },
                  }"
                  class="btn btn-success btn-sm"
                  ><i class="ri-download-2-fill align-middle me-1"></i>
                  فاکتور</RouterLink
                >
              </div>
            </div>
          </b-card-header>
          <b-card-body>
            <div class="table-responsive table-card">
              <table
                class="table table-nowrap align-middle table-borderless mb-0"
              >
                <thead class="table-light text-muted">
                  <tr>
                    <th scope="col">جزئیات محصول</th>
                    <th scope="col">قیمت</th>
                    <th scope="col">تعداد</th>
                    <th scope="col">تخفیف</th>
                    <th scope="col" class="text-end">مبلغ کل</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, index) of orderDetails.items" :key="index">
                    <td>
                      <div class="d-flex">
                        <div
                          class="flex-shrink-0 avatar-md bg-light rounded p-1"
                        >
                          <img
                            :src="item.product.image"
                            alt=""
                            class="img-fluid d-block"
                          />
                        </div>
                        <div class="flex-grow-1 ms-3">
                          <h5 class="fs-15">
                            <router-link to="" class="link-primary"
                              >{{ item.product.name }}
                            </router-link>
                          </h5>
                          <p
                            v-for="(value, index) of item.product.values"
                            :key="index"
                            class="text-muted mb-0"
                          >
                            {{ value.attributeName }}:
                            <span class="fw-medium">{{ value.valueName }}</span>
                          </p>
                          <p
                            v-if="item.product.createdBy"
                            class="text-muted mb-0 mt-1"
                          >
                            <strong>فروشگاه: </strong>
                            <span class="fw-medium">{{
                              item.product.createdBy
                            }}</span>
                          </p>
                        </div>
                      </div>
                    </td>
                    <td>{{ formattedPrices(item.originalPrice) }}</td>
                    <td>{{ persianTools.digitsEnToFa(item.qty) }}</td>
                    <td>
                      <div v-if="item.discountDetails">
                        <p
                          v-if="typeof item.discountDetails === 'string'"
                          v-html="parseDiscountDetails(item.discountDetails)"
                        ></p>
                        <p v-else>
                          <strong>نوع تخفیف:</strong>
                          {{ item.discountDetails.type }}<br />
                          <strong>مقدار تخفیف:</strong>
                          {{ item.discountDetails.amount }}<br />
                          <strong>درصد تخفیف:</strong>
                          {{ item.discountDetails.percent }}<br />
                          <strong>قیمت با تخفیف:</strong>
                          {{ item.discountDetails.priceWithDiscount }}
                        </p>
                      </div>

                      <!-- نمایش پیغام در صورتی که تخفیف موجود نباشد -->
                      <p v-else>تخفیف موجود نیست.</p>
                    </td>
                    <td class="fw-medium text-end">
                      {{ formattedPrices(item.price) }}
                    </td>
                  </tr>
                  <tr class="border-top border-top-dashed">
                    <td colspan="3"></td>
                    <td colspan="2" class="fw-medium p-0">
                      <table class="table table-borderless mb-0">
                        <tbody>
                          <tr>
                            <td>جمع جزء :</td>
                            <td class="text-end">
                              {{ formattedPrices(orderDetails.subTotal) }}
                            </td>
                          </tr>
                          <tr>
                            <td>هزینه ارسال پست :</td>
                            <td class="text-end">
                              {{ formattedPrices(orderDetails.shippingCost) }}
                            </td>
                          </tr>
                          <tr>
                            <td>هزینه مالیات :</td>
                            <td class="text-end">
                              {{ formattedPrices(orderDetails.taxAmount) }}
                            </td>
                          </tr>
                          <tr class="border-top border-top-dashed">
                            <th scope="row">جمع کل (تومان) :</th>
                            <th class="text-end">
                              {{ formattedPrices(orderDetails.totalPrice) }}
                            </th>
                          </tr>
                        </tbody>
                      </table>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </b-card-body>
        </b-card>
        <b-card no-body>
          <b-card-header>
            <div class="d-sm-flex align-items-center">
              <h5 class="card-title flex-grow-1 mb-0">وضعیت سفارش</h5>
              <div class="flex-shrink-0 mt-2 mt-sm-0">
                <b-link
                  href="javascript:void(0);"
                  class="btn btn-soft-info btn-sm mt-2 mt-sm-0 shadow-none"
                  ><i class="ri-information-line align-middle me-1"></i>
                  {{ statusLabels[orderDetails.status] }}</b-link
                >
              </div>
            </div>
          </b-card-header>
        </b-card>

        <b-card no-body>
          <b-card-header>
            <div class="d-sm-flex align-items-center">
              <CustomerLocation v-if="customerLocation" :customerLocation="customerLocation" />
            </div>
          </b-card-header>
        </b-card>
      </b-col>
      <b-col xl="3">
        <b-card no-body>
          <b-card-header>
            <div class="d-flex">
              <h5 class="card-title flex-grow-1 mb-0">مشخصات مشتری</h5>
              <div class="flex-shrink-0">
                <b-link
                  href="javascript:void(0);"
                  class="link-secondary"
                ></b-link>
              </div>
            </div>
          </b-card-header>
          <b-card-body>
            <ul class="list-unstyled mb-0 vstack gap-3">
              <li>
                <div class="d-flex align-items-center">
                  <div class="flex-grow-1">
                    <h6 class="fs-14 mb-1">
                      {{
                        userInfo ? userInfo.name + " " + userInfo.surname : ""
                      }}
                    </h6>
                    <p class="text-muted mb-0">مشتری</p>
                  </div>
                </div>
              </li>
              <li>
                <i class="ri-mail-line me-2 align-middle text-muted fs-16"></i
                >{{ userInfo ? userInfo.email : "" }}
              </li>
              <li>
                <i class="ri-phone-line me-2 align-middle text-muted fs-16"></i
                >{{ userInfo ? persianTools.digitsEnToFa(userInfo.phone) : "" }}
              </li>
            </ul>
          </b-card-body>
        </b-card>
        <b-card no-body>
          <b-card-header>
            <h5 class="card-title mb-0">
              <i class="ri-map-pin-line align-middle me-1 text-muted"></i>
              آدرس دریافت سفارش
            </h5>
          </b-card-header>
          <b-card-body>
            <ul class="list-unstyled vstack gap-2 fs-13 mb-0">
              <li>
                <strong>آدرس: </strong>
                {{ orderDetails ? orderDetails.deliveryAddress : "" }}
              </li>
              <li>
                <strong>کد پستی: </strong>
                {{
                  orderDetails
                    ? persianTools.digitsEnToFa(
                        Number(orderDetails.deliveryPostalCode)
                      )
                    : ""
                }}
              </li>
            </ul>
          </b-card-body>
        </b-card>

        <b-card no-body>
          <b-card-header>
            <h5 class="card-title mb-0">
              <i
                class="ri-file-text-line align-bottom me-1 text-muted"
              ></i>
              توضیحات سفارش
            </h5>
          </b-card-header>

          <b-card-body>
            <div class="d-flex align-items-center mb-2">
              <div class="flex-shrink-0">
                <p class="text-muted mb-0">توضیحات:</p>
              </div>
              <div class="flex-grow-1 ms-2">
                <h6 class="mb-0">
                  {{ orderDetails ? orderDetails.description : "" }}
                </h6>
              </div>
            </div>
          </b-card-body>
        </b-card>

        <b-card no-body>
          <b-card-header>
            <h5 class="card-title mb-0">
              <i
                class="ri-secure-payment-line align-bottom me-1 text-muted"
              ></i>
              جزئیات پرداخت
            </h5>
          </b-card-header>
          <b-card-body v-if="orderDetails.transactionInfo">
            <div class="d-flex align-items-center mb-2">
              <div class="flex-shrink-0">
                <p class="text-muted mb-0">کد رهگیری تراکنش:</p>
              </div>
              <div class="flex-grow-1 ms-2">
                <h6 class="mb-0">
                  {{
                    orderDetails.transactionInfo
                      ? orderDetails.transactionInfo.paymentId
                      : ""
                  }}
                </h6>
              </div>
            </div>
            <div class="d-flex align-items-center mb-2">
              <div class="flex-shrink-0">
                <p class="text-muted mb-0">روش پرداخت:</p>
              </div>
              <div class="flex-grow-1 ms-2">
                <h6 class="mb-0">
                  {{ orderDetails ? orderDetails.paymentType : "" }}
                </h6>
              </div>
            </div>
            <div class="d-flex align-items-center mb-2">
              <div class="flex-shrink-0">
                <p class="text-muted mb-0">وضعیت پرداخت:</p>
              </div>
              <div class="flex-grow-1 ms-2">
                <span
                  class="badge text-uppercase"
                  :class="{
                    'badge-soft-info':
                      orderDetails.transactionInfo.status == 'STATUS_PENDING',
                    'badge-soft-success':
                      orderDetails.transactionInfo.status == 'STATUS_SUCCESS',
                    'badge-soft-danger':
                      orderDetails.transactionInfo.status == 'STATUS_FAILED',
                  }"
                >
                  {{
                    orderDetails.transactionInfo
                      ? transactionStatusLabels[
                          orderDetails.transactionInfo.status
                        ]
                      : ""
                  }}
                </span>
              </div>
            </div>
            <div class="d-flex align-items-center">
              <div class="flex-shrink-0">
                <p class="text-muted mb-0">مبلغ:</p>
              </div>
              <div class="flex-grow-1 ms-2">
                <h6 class="mb-0">
                  {{
                    orderDetails.transactionInfo
                      ? formattedPrices(orderDetails.transactionInfo.paid)
                      : ""
                  }}
                </h6>
              </div>
            </div>
          </b-card-body>

          <b-card-body v-else>
            <div class="d-flex align-items-center mb-2">
              <div class="flex-shrink-0">
                <p class="text-muted mb-0">روش پرداخت:</p>
              </div>
              <div class="flex-grow-1 ms-2">
                <h6 class="mb-0">
                  {{ orderDetails ? orderDetails.paymentType : "" }}
                </h6>
              </div>
            </div>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>
  </Layout>
</template>
